module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_prp04-831c443493326d4b07f68ccafae11730.svg";